import { Ref } from 'react';
import { cva, VariantProps } from 'class-variance-authority';
import IcoMoon, { IconProps as DefaultProps } from 'react-icomoon';
import { cn } from '@anytag/shared-utils';
import { IconNames, icoMoonSet } from '@anytag/shared-assets';

const iconVariants = cva('flex-none', {
  variants: {
    variant: {
      none: '', // Used for some color icons: FB, YT,... or have multiple tones
      white: cn('icon-color-white'),
      'light-gray': cn('icon-color-light-gray'), // #C5D0DA
      'menu-default': cn('icon-color-secondary'), // #71717B
      'medium-gray': cn('icon-color-medium-gray'), // #A8B4BF
      gray: cn('icon-color-gray'), // #6E7C89
      red: cn('icon-color-red'), // #FF2B52
      black: cn('icon-color-black'), // #27313B
      'black-light': cn('icon-color-black-light'), // #3b4146
      blue: cn('icon-color-blue'),
      green: cn('icon-color-green'), // #40B87C
      yellow: cn('icon-color-yellow'), // #ffb63d
      inherit: cn('icon-color-inherit'),
      'light-red': cn('icon-color-light-red') // #FF5F5F
    }
  },
  defaultVariants: { variant: 'inherit' }
});

interface IconProps extends Omit<DefaultProps, 'color'>, VariantProps<typeof iconVariants> {
  disabled?: boolean;
  icon: IconNames | '';
  ref?: Ref<SVGElement>;
}
export const Icon = ({ variant, className, disabled, ...restProps }: IconProps) => (
  <IcoMoon
    iconSet={icoMoonSet}
    className={cn(iconVariants({ variant }), !!restProps.onClick && !disabled && 'icon-clickable', className)}
    {...restProps}
  />
);

export type { IconProps };
